import React from 'react';
import { ReactCalendarItemRendererProps, TimelineItemBase } from 'react-calendar-timeline';
import { getPriorityItemColour, getUtilisationItemColour } from '../../utils/Utils';
import PriorityQueries from '../admin/PriorityQueries';

interface ITimelineItemRendererProps {
  itemRendererProps: ReactCalendarItemRendererProps;
  onDoubleClick: (item: TimelineItemBase<number>) => void;
  onContextMenu: (item: TimelineItemBase<number>) => void;
}

export const TimelineItemRenderer = (props: ITimelineItemRendererProps) => {
  const { item, itemContext, getItemProps, getResizeProps } = props.itemRendererProps;
  const { left: leftResizeProps, right: rightResizeProps } = getResizeProps();
  const { HasPermissionToEdit } = PriorityQueries();
  const { data: permission } = HasPermissionToEdit(item.priority?.employeeID!);
  const hasPermission = permission ?? false;

  const isUtilisationItem = item.utilisation !== undefined;
  const isSelected = itemContext.selected && !isUtilisationItem && hasPermission;
  item.canMove = hasPermission && !isUtilisationItem;
  item.canResize = hasPermission && !isUtilisationItem;

  const priorityColour = item.priority?.status
    ? getPriorityItemColour(item.priority.status)
    : getUtilisationItemColour(item.utilisation || 0);
  const background = isSelected ? 'rgba(0, 0, 0, 0.8)' : priorityColour;
  const borderColor = isSelected ? 'green' : priorityColour;

  return item.utilisation !== 0 ? (
    <div
      {...getItemProps({
        style: {
          border: undefined,
          background: isUtilisationItem
            ? `linear-gradient(45deg, ${background} 25%, #fff 25%, #fff 50%, ${background} 50%, ${background} 75%, #fff 75%, #fff 100%`
            : background,
          backgroundSize: `5px 5px`,
          color: isUtilisationItem ? 'black' : 'white',
          fontSize: 'small',
          borderStyle: 'solid',
          borderColor,
          borderRadius: isUtilisationItem ? 0 : 3,
          borderLeftWidth: isSelected ? 5 : 1,
          borderRightWidth: isSelected ? 5 : 1,
          borderTopWidth: 1,
          borderBottomWidth: 1,
          cursor: isUtilisationItem || !hasPermission ? 'default' : 'pointer',
        },
        onDoubleClick: () => hasPermission && props.onDoubleClick(item),
        onContextMenu: () => hasPermission && props.onContextMenu(item),
      })}
    >
      {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : null}

      <div
        style={{
          height: itemContext.dimensions.height,
          overflow: 'hidden',
          paddingLeft: 3,
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        <span
          style={{
            backgroundColor: isUtilisationItem ? 'white' : 'transparent',
            borderRadius: 5,
            padding: 2,
            fontWeight: isUtilisationItem ? 500 : 'normal',
          }}
        >
          {item.title}
        </span>
      </div>

      {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
    </div>
  ) : null;
};

export default TimelineItemRenderer;
